import React, { useState } from 'react';
import { X, Mail, CheckCircle } from 'lucide-react';
const FAVICON_URL = 'https://cdn.magicpatterns.com/uploads/cfHMrrPng3iagpRwV1FuNs/Favicon.jpg';
interface CVRequestModalProps {
  expertName: string;
  expertRole: string;
  isOpen: boolean;
  onClose: () => void;
}
export function CVRequestModal({
  expertName,
  expertRole,
  isOpen,
  onClose
}: CVRequestModalProps) {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  if (!isOpen) return null;
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !email.includes('@') || !email.includes('.')) {
      setError('Please enter a valid email address.');
      return;
    }
    setError('');
    setSubmitted(true);
    // In production, this would trigger an API call to send the CV
    console.log(`CV requested for ${expertName} by ${email}`);
  };
  const handleClose = () => {
    setEmail('');
    setSubmitted(false);
    setError('');
    onClose();
  };
  return <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" data-id="element-103">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-ink-900/50 backdrop-blur-sm" onClick={handleClose} data-id="element-104" />

      {/* Modal */}
      <div className="relative bg-white rounded-2xl shadow-2xl border border-warm-200 w-full max-w-md overflow-hidden" data-id="element-105">
        {/* Close button */}
        <button onClick={handleClose} className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-lg text-ink-400 hover:text-ink-600 hover:bg-warm-100 transition-colors z-10" aria-label="Close modal" data-id="element-106">
          <X className="h-5 w-5" data-id="element-107" />
        </button>

        <div className="p-8" data-id="element-108">
          {!submitted ? <>
              {/* Logo */}
              <img src={FAVICON_URL} alt="UK Medicolegal Assessments shield logo" className="h-12 w-12 rounded-xl object-contain mb-6" data-id="element-109" />

              <h3 className="text-xl font-bold text-ink-900 mb-2" data-id="element-110">
                Request CV
              </h3>
              <p className="text-sm text-ink-500 leading-relaxed mb-6" data-id="element-111">
                Enter your email and we'll send you the full CV for{' '}
                <span className="font-semibold text-ink-700" data-id="element-112">{expertName}</span>{' '}
                ({expertRole}) straight to your inbox.
              </p>

              <form onSubmit={handleSubmit} className="space-y-4" data-id="element-113">
                <div data-id="element-114">
                  <label htmlFor="cv-email" className="block text-sm font-semibold text-ink-900 mb-2" data-id="element-115">
                    Your Email Address
                  </label>
                  <input type="email" id="cv-email" className="input-field" placeholder="john@lawfirm.co.uk" value={email} onChange={e => {
                setEmail(e.target.value);
                setError('');
              }} autoFocus data-id="element-116" />
                  {error && <p className="text-sm text-red-600 mt-1.5" data-id="element-117">{error}</p>}
                </div>

                <button type="submit" className="btn-primary w-full text-center" data-id="element-118">
                  <Mail className="mr-2 h-5 w-5" data-id="element-119" />
                  Send CV to My Email
                </button>
              </form>

              <p className="text-xs text-ink-400 text-center mt-4 leading-relaxed" data-id="element-120">
                We'll only use your email to send the requested CV. See our{' '}
                <a href="/privacy-policy" className="text-teal-600 hover:underline" data-id="element-121">
                  Privacy Policy
                </a>
                .
              </p>
            </> : <div className="text-center py-4" data-id="element-122">
              <div className="w-16 h-16 bg-sage-50 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-123">
                <CheckCircle className="h-8 w-8 text-sage-600" data-id="element-124" />
              </div>
              <h3 className="text-xl font-bold text-ink-900 mb-2" data-id="element-125">CV Sent</h3>
              <p className="text-sm text-ink-500 leading-relaxed mb-6" data-id="element-126">
                The CV for{' '}
                <span className="font-semibold text-ink-700" data-id="element-127">{expertName}</span>{' '}
                has been sent to{' '}
                <span className="font-semibold text-ink-700" data-id="element-128">{email}</span>.
                Please check your inbox.
              </p>
              <button onClick={handleClose} className="btn-secondary w-full text-center" data-id="element-129">
                Close
              </button>
            </div>}
        </div>
      </div>
    </div>;
}